import { caption } from './caption.js';
import { body1 } from './body1.js';
import { body2 } from './body2.js';
import { paragraph1 } from './paragraph1.js';
import { paragraph2 } from './paragraph2.js';
import { title1, title2, title3, title4 } from './titles.js';
import { price1 } from './price1.js';
import { price2 } from './price2.js';

var variants = {
  caption: caption,
  body1: body1,
  body2: body2,
  paragraph1: paragraph1,
  paragraph2: paragraph2,
  title1: title1,
  title2: title2,
  title3: title3,
  title4: title4,
  price1: price1,
  price2: price2
};

export { variants };
//# sourceMappingURL=index.js.map
